import { Login2fa } from "./components/Login/Login2fa";
import { Home } from "./components/Home/Home";
import { About } from "./components/About";
import { UserProfile } from 'components/UserProfile/UserProfile';
import { ResetPassword } from 'components/UserProfile/ResetPassword';
import { UserManagement } from "./components/UserManagement/UserManagement";
import { NewUser } from "./components/UserManagement/NewUser/NewUser";
import { EditUser } from "./components/UserManagement/EditUser/EditUser";
import { AuditManagement } from "./components/AuditManagement/AuditManagement";
import { PseudoCodeManagement } from "./components/PseudoCodesManagement/PseudoCodeManagement";
import {ControlCentresPanel} from './components/ControlCentresPanel/ControlCentresPanel';
import { ControlCentreConfig } from './components/ControlCentresPanel/ControlCentreConfig/ControlCentreConfig';
import { InterventionTypeManagement } from "./components/InterventionTypeManagement/InterventionTypeManagement";
import { NewInterventionType } from "./components/InterventionTypeManagement/NewInterventionType/NewInterventionType";
import { EditInterventionType } from "./components/InterventionTypeManagement/EditInterventionType/EditInterventionType";
import { InterventionManagement } from "./components/InterventionManagement/InterventionManagement";

const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
    {
        path: '/login2fa',
        element: <Login2fa />
    },
    {
        path: '/home',
        element: <Home />
    },
    {
        path: '/about',
        element: <About />
    },
    {
        path: '/userProfile',
        element: <UserProfile />
    },
    {
        path: '/resetPassword',
        element: <ResetPassword />
    },
    {
        path: '/userManagement',
        element: <UserManagement />
    },
    {
        path: '/users/newUser',
        element: <NewUser />
    },
    {
        path: '/user/editUser/:personId',
        element: <EditUser />
    },
    {
        path: '/auditManagement',
        element: <AuditManagement />
    },
    {
        path : '/pseudocodesManagement/:centreid',
        element : <PseudoCodeManagement/>
    },
    {
        path : '/controlCentresPanel',
        element : <ControlCentresPanel/>
    },
    {
        path : '/controlCentreConfig/:centreid',
        element : <ControlCentreConfig/>
    },
    {
        path: '/interventionTypeManagement',
        element: <InterventionTypeManagement />
    },
    {
        path: '/interventionTypeManagement/newInterventionType',
        element: <NewInterventionType />
    },
    {
        path: '/interventionTypeManagement/editInterventionType/:id',
        element: <EditInterventionType />
    },
    {
        path: '/interventionManagement',
        element: <InterventionManagement/>
    },
];

export default AppRoutes;
